// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"add2150d","91":"9885f4cb","162":"cedf5c37","215":"a9ee516a","485":"76e3b769","493":"dbfea198","676":"5cc25aef","748":"1dbf2f9a","827":"114fb5a5","900":"b60fbff5","924":"40aa789f","976":"735c7ac3"}[chunkId] + ".chunk.js";
};